<script setup>
import { computed } from 'vue';
import FacebookIcon from 'dashboard/assets/brands/FacebookIcon.vue';
import WhatsappIcon from 'dashboard/assets/brands/WhatsappIcon.vue';
import TelegramIcon from 'dashboard/assets/brands/TelegramIcon.vue';
import ZaloIcon from 'dashboard/assets/brands/ZaloIcon.vue';
import MessengerIcon from 'dashboard/assets/brands/MessengerIcon.vue';
import WebsiteIcon from 'dashboard/assets/brands/WebsiteIcon.vue';
import MsmIcon from 'dashboard/assets/brands/MsmIcon.vue';
import EmailIcon from 'dashboard/assets/brands/EmailIcon.vue';
import LineIcon from 'dashboard/assets/brands/LineIcon.vue';
const props = defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 18 },
  class: String,
});

const map = { 
  facebook: FacebookIcon,
  whatsapp: WhatsappIcon,
  telegram: TelegramIcon,
  zalo: ZaloIcon,
  messenger: MessengerIcon,
  website: WebsiteIcon,
  sms: MsmIcon,
  email: EmailIcon,
  line: LineIcon,
};
const Icon = computed(() => map[props.name]);
</script>

<template>
  <component v-if="Icon" :is="Icon" :size="size" :class="class" />
</template>